import React, { useMemo } from 'react';
import { TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEntityContext } from '../EntityContext';
export const EntitySchemaPicker = props => {
    const { value, disabled, className, filterRelations, textFieldProps, onChange } = props;
    const { entities, loadingEntities: isLoading, loadingEntitiesError: error } = useEntityContext();
    const options = useMemo(() => {
        return (entities || []).filter(schema => {
            // filter relations
            const isRelated = !filterRelations ||
                !schema.relations ||
                schema.relations.some(relation => {
                    return filterRelations.includes(relation.target);
                });
            return isRelated;
        });
    }, [entities, filterRelations]);
    const selected = useMemo(() => {
        return entities === null || entities === void 0 ? void 0 : entities.find(schema => schema.name === value);
    }, [value, entities]);
    return (React.createElement(Autocomplete, { options: options, disabled: disabled, loading: isLoading, className: className, value: selected || null, getOptionLabel: option => option.displayName, onChange: (_, value) => onChange === null || onChange === void 0 ? void 0 : onChange(value || undefined), renderOption: option => (React.createElement("span", null,
            React.createElement(Typography, null, option.displayName),
            option.displayName !== option.name && (React.createElement(Typography, { variant: 'body2', color: 'textSecondary' }, option.name)))), renderInput: params => (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, variant: 'outlined', label: 'Select Entity Schema', error: !!error, helperText: error === null || error === void 0 ? void 0 : error.message }, textFieldProps))) }));
};
export default EntitySchemaPicker;
//# sourceMappingURL=EntitySchemaPicker.js.map